import { render } from "./imagePreview.vue?vue&type=template&id=632a168c"
import script from "./imagePreview.vue?vue&type=script&lang=js"
export * from "./imagePreview.vue?vue&type=script&lang=js"

import "./imagePreview.vue?vue&type=style&index=0&id=632a168c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__